/**
 * Elevenlabs Text to Speech Voices - https://elevenlabs.io/docs/api-reference/models/get-all?playground=%2Fdocs%2Fapi-reference%2Fvoices%2Fget-all
 * Response Formats - https://elevenlabs.io/docs/capabilities/text-to-speech#supported-formats
 * todo sample rate and bitrate can be added in the response format
 **/

export type ElevenlabsModel = "eleven_multilingual_v2" | "eleven_flash_v2_5" | "eleven_turbo_v2_5"

export const ElevenlabsModelSpeechModel: { [key in ElevenlabsModel]: string } = {
  //    "eleven_multilingual_v2" most life-like, emotionally rich mode. Best for voice overs, audiobooks, post-production, or any other content creation.
  eleven_multilingual_v2: "Eleven Multilingual v2",
  //    "eleven_flash_v2_5" ultra low latency model. Ideal for conversational use cases
  eleven_flash_v2_5: "Eleven Flash v2.5",
  //    "eleven_turbo_v2_5" high quality, low latency model. Best for developer use cases where speed matters and you need non-English languages.
  eleven_turbo_v2_5: "Eleven Turbo v2.5",
}

export type ElevenlabsVoice =
  | "9BWtsMINqrJLrRacOk9x"
  | "CwhRBWXzGAHq8TQ4Fs17"
  | "EXAVITQu4vr4xnSDxMaL"
  | "FGY2WhTYpPnrIDTdsKH5"
  | "IKne3meq5aSn9XLyUdCD"
  | "JBFqnCBsd6RMkjVDRZzb"
  | "N2lVS1w4EtoT3dr4eOWO"
  | "SAz9YHcvj6GT2YYXdXww"
  | "TX3LPaxmHKxFdv7VOQHJ"
  | "XB0fDUnXU5powFXDhCwa"
  | "Xb7hH8MSUJpSbSDYk0k2"
  | "XrExE9yKIg1WjnnlVkGX"
  | "bIHbv24MWmeRgasZH58o"
  | "cgSgspJ2msm6clMCkdW9"
  | "cjVigY5qzO86Huf0OWal"
  | "iP95p4xoKVk53GoZ742B"
  | "nPczCjzI2devNBz1zQrb"
  | "onwK4e9ZLuTAKqWW03F9"
  | "pFZP5JQG7iQjIQuC4Bku"
  | "pqHfZKP75CvOlQylNhV4"
  | "j52AnihQTabQP3btXfEK"
  | "21m00Tcm4TlvDq8ikWAM"
  | "GUVT8bwap7ZLQORDRhgz"

export const ElevenlabsVoice: { [key in ElevenlabsVoice]: string } = {
  "9BWtsMINqrJLrRacOk9x": "Aria (female) (English (US))",
  "CwhRBWXzGAHq8TQ4Fs17": "Roger (male) (English (US))",
  "EXAVITQu4vr4xnSDxMaL": "Sarah (female) (English (US))",
  "FGY2WhTYpPnrIDTdsKH5": "Laura (female) (English (US))",
  "IKne3meq5aSn9XLyUdCD": "Charlie (male) (English (AU))",
  "JBFqnCBsd6RMkjVDRZzb": "George (male) (English (UK))",
  "N2lVS1w4EtoT3dr4eOWO": "Callum (male) (English (Transatlantic))",
  "SAz9YHcvj6GT2YYXdXww": "River (non-binary) (English (US))",
  "TX3LPaxmHKxFdv7VOQHJ": "Liam (male) (English (US))",
  "XB0fDUnXU5powFXDhCwa": "Charlotte (female) (English (Swedish))",
  "Xb7hH8MSUJpSbSDYk0k2": "Alice (female) (English (UK))",
  "XrExE9yKIg1WjnnlVkGX": "Matilda (female) (English (US))",
  "bIHbv24MWmeRgasZH58o": "Will (male) (English (US))",
  "cgSgspJ2msm6clMCkdW9": "Jessica (female) (English (US))",
  "cjVigY5qzO86Huf0OWal": "Eric (male) (English (US))",
  "iP95p4xoKVk53GoZ742B": "Chris (male) (English (US))",
  "nPczCjzI2devNBz1zQrb": "Brian (male) (English (US))",
  "onwK4e9ZLuTAKqWW03F9": "Daniel (male) (English (UK))",
  "pFZP5JQG7iQjIQuC4Bku": "Lily (female) (English (UK))",
  "pqHfZKP75CvOlQylNhV4": "Bill (male) (English (US))",
  "j52AnihQTabQP3btXfEK": "Neona (female) (Multilingual)",
  "21m00Tcm4TlvDq8ikWAM": "Rachel (female) (English)",
  "GUVT8bwap7ZLQORDRhgz": "Sofia (female) (English)",
}
export type ElevenlabsResponseFormat =
  /**
   * Output format, mp3 with 22.05kHz sample rate at 32kbps */
  | "mp3_22050_32"
  /**
   * Output format, mp3 with 44.1kHz sample rate at 32kbps */
  | "mp3_44100_32"
  /**
   * Output format, mp3 with 44.1kHz sample rate at 64kbps */
  | "mp3_44100_64"
  /**
   * Output format, mp3 with 44.1kHz sample rate at 96kbps */
  | "mp3_44100_96"
  /**
   * Default output format, mp3 with 44.1kHz sample rate at 128kbps */
  | "mp3_44100_128"
  /**
   * Output format, mp3 with 44.1kHz sample rate at 192kbps. */
  | "mp3_44100_192"
  /**
   * PCM format (S16LE) with 16kHz sample rate. */
  | "pcm_16000"
  /**
   * PCM format (S16LE) with 22.05kHz sample rate. */
  | "pcm_22050"
  /**
   * PCM format (S16LE) with 24kHz sample rate. */
  | "pcm_24000"
  /**
   * μ-law format (sometimes written mu-law, often approximated as u-law) with 8kHz sample rate. Note that this format is commonly used for Twilio audio inputs. */
  | "ulaw_8000"
export const ElevenlabsResponseFormat: { [key in ElevenlabsResponseFormat]: string } = {
  mp3_22050_32: "mp3 (22.05kHz at 32kbps)",
  mp3_44100_32: "mp3 (44.1kHz at 32kbps)",
  mp3_44100_64: "mp3 (44.1kHz at 64kbps)",
  mp3_44100_96: "mp3 (44.1kHz at 96kbps)",
  mp3_44100_128: "mp3 (44.1kHz at 128kbps)",
  mp3_44100_192: "mp3 (44.1kHz at 192kbps)",
  pcm_16000: "PCM (16kHz sample rate)",
  pcm_22050: "PCM (22.05kHz sample rate)",
  pcm_24000: "PCM (24kHz sample rate)",
  ulaw_8000: "μ-law (8kHz sample rate)",
}
